export default __webpack_public_path__ + "static/media/IMG-20210701-WA0032.87963028.jpg";